import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
export function FinalRecap() {
  return <section className="py-8 md:py-12 px-4 md:px-6 lg:px-8 bg-black" data-id="element-83">
      <div className="max-w-3xl mx-auto text-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} data-id="element-85">
          <h2 className="text-xl md:text-2xl font-black text-white tracking-tight mb-5" data-id="element-86">
            Una Vez Más, Todo Lo Que Recibirás
          </h2>

          <div className="bg-white/5 backdrop-blur-sm p-5 rounded-xl border border-white/10 text-left mb-5" data-id="element-87">
            <ul className="space-y-2 font-medium text-white/90 text-xs md:text-sm" data-id="element-88">
              <li className="flex items-start gap-2" data-id="element-89">
                <span className="text-orange font-bold mt-0.5" data-id="element-90">✓</span>
                Acceso completo a Renovación Sin Obras — Sistema 4 Horas por
                Ambientes
              </li>
              <li className="flex items-start gap-2" data-id="element-91">
                <span className="text-orange font-bold mt-0.5" data-id="element-92">✓</span>
                Más de 50 soluciones prácticas para modernizar tu casa
              </li>
              <li className="flex items-start gap-2" data-id="element-93">
                <span className="text-orange font-bold mt-0.5" data-id="element-94">✓</span>
                Formato 100% Digital — Acceso inmediato
              </li>
              <li className="flex items-start gap-2" data-id="element-95">
                <span className="text-orange font-bold mt-0.5" data-id="element-96">✓</span>5 Bonos
                Exclusivos incluidos sin costo extra
              </li>
              <li className="flex items-start gap-2" data-id="element-97">
                <span className="text-orange font-bold mt-0.5" data-id="element-98">✓</span>
                Método aplicable incluso si vivís en alquiler
              </li>
              <li className="flex items-start gap-2" data-id="element-99">
                <span className="text-orange font-bold mt-0.5" data-id="element-100">✓</span>
                Pago único — Sin cargos mensuales
              </li>
              <li className="flex items-start gap-2" data-id="element-101">
                <span className="text-orange font-bold mt-0.5" data-id="element-102">✓</span>
                Garantía de 30 días
              </li>
            </ul>
          </div>

          <div className="mb-5" data-id="element-103">
            <p className="text-xs text-white/50 font-bold mb-1 uppercase tracking-wider" data-id="element-104">
              Valor total:{' '}
              <span className="line-through" data-id="element-105">
                <PriceDisplay amount={186940} data-id="element-106" />
              </span>
            </p>
            <p className="text-xl md:text-2xl text-orange font-black tracking-tight" data-id="element-107">
              Pago único hoy: <PriceDisplay amount={19990} data-id="element-108" />
            </p>
          </div>

          <a href="https://bibliadigital.myshopify.com//cart/add?id=47688902443165&quantity=1" onClick={() => {
          if (typeof (window as any).fbq === 'function') (window as any).fbq('track', 'AddToCart');
        }} className="inline-block w-full md:w-auto text-center bg-orange text-white font-black text-base px-8 py-3.5 rounded-lg shadow-sm hover:shadow-md hover:scale-[1.02] transition-all duration-300 ease-out mb-2 uppercase tracking-wide" data-id="element-109">
            QUIERO MI RENOVACIÓN
          </a>

          <p className="text-white/60 font-bold text-xs uppercase tracking-wider" data-id="element-110">
            Acceso inmediato a Renovación Sin Obras + Todos los Bonos
          </p>
        </motion.div>
      </div>
    </section>;
}